import { KppIcon } from 'assets/UiIcons';
import { ROUTE_CONTRACT_WIZARD } from 'lib/constants';
import React from 'react';
import { PropAlignment } from 'types/materialUi';
import { AppState, SalesType } from 'types/redux';
import {
	Card,
	CardActions,
	CardContent,
	Grid,
	makeStyles,
	Theme,
	Typography,
} from '@material-ui/core';

import { PageTitle } from '../../../components/PageTitle/PageTitle';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useUniversalTracking } from 'lib/tracking/universalTracking';
import { useHistory } from 'react-router';
import { ContinueButton } from 'components/ContinueButton/ContinueButton';
import ProductDescriptionList from './ProductDescriptionList';

const useStyles = makeStyles((theme: Theme) => ({
	card: {
		display: 'flex',
		flexDirection: 'column',
		width: '90%',
		[theme.breakpoints.up('xs')]: {
			width: 400,
		},
		[theme.breakpoints.up('md')]: {
			width: 460,
		},
		margin: theme.spacing(2),
		textAlign: 'center',
		position: 'relative',
	},
	cardContent: {
		padding: theme.spacing(3),
		paddingBottom: 0,
		flexGrow: 1,
	},
	cardActions: {
		padding: theme.spacing(3),
	},
	productIcon: {
		marginBottom: theme.spacing(2),
		maxWidth: 120,
		width: 120,
		height: 120,
		color: theme.palette.primary.main,
	},
	mainSection: {
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: theme.spacing(4),
	},
	title: {
		fontSize: 20,
		marginBottom: theme.spacing(2),
	},
	description: {
		...theme.typography.body1,
		textAlign: 'left',
		marginBottom: theme.spacing(2),
	},
}));

const ProductSection = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const salesTypes = useSelector<AppState, SalesType[]>( state => state.user.salesType )||[];
	const { trackEvent } = useUniversalTracking();
	const history = useHistory();
	const trackContactTypeClick = (salesType: SalesType) => {
		trackEvent({
			category: 'choose-insurance-type',
			action: 'click-event',
			label: salesType,
		});
	};
	return (
		<Grid container className={`home_main ${classes.mainSection}`}>
			<Grid item xs={12}>
				<PageTitle
					title={salesTypes.length ? t('home.title') : t('home.titleNoProducts')}
					align={PropAlignment.CENTER}
					marginTop={6}
					marginBottom={1}
				/>
				<Grid container justifyContent="center">
					{/* kpp and kpe product */}
					<Card className={classes.card}>
						<CardContent className={classes.cardContent}>
							<KppIcon className={classes.productIcon} />

							<Typography className={classes.title} variant={'h3'}>
								{t('home.kpp.title')}
							</Typography>
							<div className={classes.description}>
								<ProductDescriptionList />
							</div>
						</CardContent>

						<CardActions className={classes.cardActions}>
							<Grid container spacing={1} justifyContent="center">
								{/* kpe button */}
								{salesTypes.includes(SalesType.KPE) && (
									<Grid item xs={12} sm={6}>
										<ContinueButton
											data-cy="continue-button-kpe"
											onClick={() => {
												trackContactTypeClick(SalesType.KPE);
												history.push(
													`/${ROUTE_CONTRACT_WIZARD}/${SalesType.KPE}`
												);
											}}
										>
											{t('home.kpe.buttonLabel')}
										</ContinueButton>
									</Grid>
								)}
								{/* kpp button */}
								{salesTypes.includes(SalesType.KPP) && (
									<Grid item xs={12} sm={6}>
										<ContinueButton
											data-cy="continue-button-kpp"
											onClick={() => {
												trackContactTypeClick(SalesType.KPP);
												history.push(
													`/${ROUTE_CONTRACT_WIZARD}/${SalesType.KPP}`
												);
											}}
										>
											{t('home.kpp.buttonLabel')}
										</ContinueButton>
									</Grid>
								)}
								{/* keh button */}
								{salesTypes.includes(SalesType.KEH) && (
									<Grid item xs={12} sm={6}>
										<ContinueButton
											data-cy="continue-button-keh"
											className="keh"
											onClick={() => {
												trackContactTypeClick(SalesType.KEH);
												history.push(
													`/${ROUTE_CONTRACT_WIZARD}/${SalesType.KEH}`
												);
											}}
										>
											{t('home.keh.buttonLabel')}
										</ContinueButton>
									</Grid>
								)}
								{/* epe button */}
								{salesTypes.includes(SalesType.EPK) && (
									<Grid item xs={12} sm={6}>
										<ContinueButton
											data-cy="continue-button-epk"
											onClick={() => {
												trackContactTypeClick(SalesType.EPK);
												history.push(
													`/${ROUTE_CONTRACT_WIZARD}/${SalesType.EPK}`
												);
											}}
										>
											{t('home.epk.buttonLabel')}
										</ContinueButton>
									</Grid>
								)}
								{/* epm button */}
								{salesTypes.includes(SalesType.EPH) && (
									<Grid item xs={12} sm={6}>
										<ContinueButton
											data-cy="continue-button-eph"
											onClick={() => {
												trackContactTypeClick(SalesType.EPH);
												history.push(
													`/${ROUTE_CONTRACT_WIZARD}/${SalesType.EPH}`
												);
											}}
										>
											{t('home.eph.buttonLabel')}
										</ContinueButton>
									</Grid>
								)}
							</Grid>
						</CardActions>
					</Card>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ProductSection;
